import { render } from "./wf-klb.vue?vue&type=template&id=7645cd96&scoped=true"
import script from "./wf-klb.vue?vue&type=script&lang=js"
export * from "./wf-klb.vue?vue&type=script&lang=js"

import "./wf-klb.vue?vue&type=style&index=0&id=7645cd96&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7645cd96"]])

export default __exports__